import LockIcon from './LockIcon';

export default LockIcon;
